/* !
 * jQuery corporate v1.0.0
 * Copyright 2026, Connecty Inc.
 */
(function($, FUNCTIONS){
	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}
	const a = 'is-active';

	// ＜研究開発での実績＞タブ切り替え
	const expansionTab = () => {
		const $tab = $('.js-tab');
		if (!$tab.length) return;

		const $tabLinks = $tab.find('a');
		const $sections = $tabLinks.map((idx, ele) => {
			return $($(ele).attr('href'))[0];
		});

		// タブを指定IDで切り替える
		const activateTab = (tabId) => {
			const $target = $tabLinks.filter('[href="#' + tabId + '"]');
			if (!$target.length) return false;
			$tabLinks.removeClass(a);
			$target.addClass(a);
			$sections.each((idx, ele) => { $(ele).hide(); });
			$('#' + tabId).show();
			return true;
		};

		// ハッシュからタブ＋アコーディオンを復元
		const restoreFromHash = () => {
			const hash = location.hash.replace('#', '');
			if (!hash) return false;
			const parts = hash.split('-');
			const tabId = parts[0];
			const year = parts[1];
			if (activateTab(tabId)) {
				let $scrollTarget = $('#' + tabId);
				if (year) {
					// 全アコーディオンを閉じてから対象を開く
					$('#' + tabId).find('.js-toggle').removeClass(a);
					$('#' + tabId).find('.js-toggleBlock').css('display', 'none');
					$('#' + tabId).find('.js-toggle').each(function() {
						const text = $(this).text().trim();
						if (text.indexOf(year) !== -1) {
							$(this).addClass(a);
							$(this).next('.js-toggleBlock').css('display', 'block');
							$scrollTarget = $(this);
						}
					});
				}
					return true;
			}
			return false;
		};

		// 初期状態：ハッシュがあれば復元、なければ最初のタブ
		if (!restoreFromHash()) {
			$tabLinks.eq(0).addClass(a);
			$sections.each((idx, ele) => {
				if (idx !== 0) $(ele).hide();
			});
		}

		$tabLinks.on('click', (e) => {
			e.preventDefault();
			const $this = $(e.currentTarget);
			const target = $this.attr('href');

			// タブのアクティブ切り替え
			$tabLinks.removeClass(a);
			$this.addClass(a);

			// セクション表示切り替え
			$sections.each((idx, ele) => {
				$(ele).hide();
			});
			$(target).show();

			// URLのハッシュをタブIDに更新
			history.replaceState(null, '', target);
		});

		// PDFリンククリック時にハッシュを保存
		$sections.each((idx, ele) => {
			$(ele).find('a[href$=".pdf"]').on('click', function() {
				const tabId = $(ele).attr('id');
				const $activeToggle = $(this).closest('.js-toggleBlock').prev('.js-toggle');
				let hash = tabId;
				if ($activeToggle.length) {
					const yearMatch = $activeToggle.text().match(/\d{4}/);
					if (yearMatch) hash += '-' + yearMatch[0];
				}
				history.replaceState(null, '', '#' + hash);
			});
		});
	};

	// bfcacheで復元されたときもスクロール処理を走らせる
	window.addEventListener('pageshow', function() {
		const hash = location.hash.replace('#', '');
		if (!hash || hash.indexOf('-') === -1) return;

		const parts = hash.split('-');
		const tabId = parts[0];
		const year = parts[1];
		let target = null;

		$('#' + tabId).find('.js-toggle').each(function() {
			if ($(this).text().trim().indexOf(year) !== -1) {
				target = this;
			}
		});

		if (target) {
			setTimeout(function() {
				const headerH = $('header').length ? $('header').outerHeight() : 0;
				const top = $(target).offset().top - headerH - 20;
				window.scrollTo({ top: top, behavior: 'smooth' });
			}, 100);
		}
	});

	// ========= ↑↑ FUNCTIONS ↑↑ ========================================================================== //

	expansionTab();

})(window.jQuery, window.FUNCTIONS);
